import "./breadthingLight.scss"

import { Badge } from "@shopify/polaris"
import { LockIcon } from "@shopify/polaris-icons"
import { observer } from "mobx-react"

import { Benifit } from "@/models/ICommon"

import useBenefit from "./useBenefit"

interface IFeatureWidgetProps {
  benefits: Benifit
  fallback?: React.ReactNode
  customContent?: string
}
const FeatureWidget = (props: IFeatureWidgetProps) => {
  const { benefits, fallback, customContent } = props

  const { hasBenefits, title, handleClick } = useBenefit({ benefits })

  if (hasBenefits) return fallback ?? null
  if (customContent) {
    return (
      <div
        className="relative cursor-pointer pp-feature-widget--special"
        onClick={handleClick}
      >
        <Badge icon={LockIcon} tone="info">
          {customContent}
        </Badge>
      </div>
    )
  }
  if (!title) return fallback ?? null
  return (
    <div
      className="relative cursor-pointer pp-feature-widget"
      onClick={handleClick}
    >
      <div className="absolute top-[6px] left-[-2px] w-full h-full">
        <div className="_Indicator_1cknc_5"></div>
      </div>
      <Badge progress="complete" tone="info">
        {title}
      </Badge>
    </div>
  )
}
export default observer(FeatureWidget)
